import { ACTIVITY_DOMAIN_REGEX, ACTIVITY_DOMAIN, MOBILE_DOMAIN } from '@/const'
import { Interim } from '@/features/interim'
import { Login } from '@/features/login'
import { store, userThemeColorAtom } from '@/store'
import { Portal } from '@seiue/ui'
import { ThemeProvider } from '@seiue/ui/build/module/theme/Provider'
import { uniqBy } from '@seiue/util'
import { ConfigProvider } from 'antd'
import { routes } from 'packages/route'
import { Agreement, NotFound, Policy } from 'packages/route/components'
import { getTheme } from 'packages/theme'
import { AnyType } from 'packages/types'
import { getAllRoutesPaths } from 'packages/utils'
import React, { FC, useEffect, useState } from 'react'
import { isMobile } from 'react-device-detect'
import { createGlobalState } from 'react-hooks-global-state'
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom'
import { ThemeProvider as StyledThemeProvider } from 'styled-components'

import { UserLayout } from './Layout/UserLayout'
import { useInitUserFeatures } from './hooks'

const userThemeColor = store.get(userThemeColorAtom)
const { useGlobalState: useUserGlobalState } = createGlobalState({
  themeColor: userThemeColor,
})
export { useUserGlobalState }
/**
 * 活动界面
 *
 * @returns page
 */
export const UserHome: FC = () => {
  const userThemeColor = store.get(userThemeColorAtom)
  const [isRealPath, setIsRealPath] = useState<boolean>(false)
  useInitUserFeatures()

  const pathname = location.pathname

  const existPathNames = getAllRoutesPaths(uniqBy(routes, 'path')).map((r) => {
    const idx = r.indexOf(':')
    if (idx > -1) {
      return r.slice(0, idx - 1)
    }
    return r
  })

  const theme = getTheme(userThemeColor)
  const [, setThemeColor] = useUserGlobalState('themeColor')

  useEffect(() => {
    ConfigProvider.config({
      theme: {
        primaryColor: userThemeColor,
      },
    })

    setThemeColor(userThemeColor)
  }, [userThemeColor, ConfigProvider])

  useEffect(() => {
    const crtHref = location.href
    const isActivity = ACTIVITY_DOMAIN_REGEX.test(location.hostname)
    if (isMobile && isActivity) {
      location.href = crtHref.replace(ACTIVITY_DOMAIN, MOBILE_DOMAIN)
      return
    }
    if (
      [
        ...existPathNames,
        '/serviceAgreement',
        '/policy',
        '/404',
        '/login',
        '/interim',
      ].some((r) => pathname.startsWith(r)) ||
      pathname === '/'
    ) {
      setIsRealPath(true)
    } else {
      const param = pathname.slice(1)
      location.href = `/?${param}`
    }
  }, [setIsRealPath])

  if (!isRealPath) return null
  return (
    <ThemeProvider themeColor={userThemeColor}>
      <StyledThemeProvider theme={theme as AnyType}>
        <Portal.Host />
        <Router>
          <Switch>
            <Route
              path="/serviceAgreement"
              component={Agreement}
            />
            <Route
              path="/policy"
              component={Policy}
            />
            <Route
              path="/interim"
              component={Interim}
            />
            <Route
              path="/404"
              component={NotFound}
            />
            <Route
              path="/login"
              component={Login}
            />
            <Route render={() => <Route component={UserLayout} />} />
          </Switch>
        </Router>
      </StyledThemeProvider>
    </ThemeProvider>
  )
}
